import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Svg } from '../Icon/Base.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var _excluded = ["color"];
var IconEmail = /*#__PURE__*/React.memo(function (_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? "currentColor" : _ref$color,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/jsxs(Svg, _objectSpread(_objectSpread({
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: [/*#__PURE__*/jsx("path", {
      clipRule: "evenodd",
      d: "M1.5 6.25A1.5 1.5 0 013 4.75h18a1.5 1.5 0 011.5 1.5v12a1.5 1.5 0 01-1.5 1.5H3a1.5 1.5 0 01-1.5-1.5v-12z",
      stroke: color,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/jsx("path", {
      d: "M22.161 5.3l-8.144 6.264a3.308 3.308 0 01-4.034 0L1.84 5.3",
      stroke: color,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  }));
});
IconEmail.displayName = "IconEmail";

export { IconEmail };
